define('Components/ProductListWidget/js/models/SimpleProductListWidgetInstanceModel',['jquery','Components/ProductListWidget/js/models/ProductListWidgetInstanceModel','app'],function($,ProductListWidgetInstanceModel,app){
    return ProductListWidgetInstanceModel.extend({
        getNbSlide:function(){
            return Math.ceil(this.getProductsSize() / this.getNbProductPerSlide());
        },
        getNbProductPerSlide: function(){
            switch(this.p('template')){
                case 'simple-4x1' : return 4; break;
                case 'simple-4x2' : return 8; break;
            }
        },
        openSlide:function(n){
            return n % this.getNbProductPerSlide() == 0;
        },
        closeSlide:function(n){
            return ((n+1) % this.getNbProductPerSlide() == 0);
        }
    })
});
